<!-- START Sidebar (left)-->
<div class="aside-inner">
  <nav class="sidebar" sidebar-anyclick-close="" [class.show-scrollbar]="settings.getLayoutSetting('asideScrollbar')">

    <!-- START sidebar nav-->
    <ul class="sidebar-nav sidebar_nav">

      <!-- START user info-->
      <li class="has-user-block">
        <div class=" pt-2" >
          <a [routerLink]="['/home']">
      
              <!-- <div class="brand-logo"  >
                  <img class="img-fluid mt-2 ml-3" src="assets/img/black-logo.png" alt="FastSwiff" />
              </div> -->
             <div class="brand-logo" *ngIf="paygimage">
              <img class="img-fluid mt-2" src="assets/img/white_logo.svg" alt="FastSwiff" />
              </div>
      
               <div class="brand-logo text-center" *ngIf="image">
      
                  <img  
                      class="res-h img-fluid image-cropper-container1" src="data:image/jpeg;base64,{{content}}" alt="FastSwiff" />
              </div>
          </a>
          <!-- User picture-->
          <!-- <div class="user-block-picture">
              <div class="user-block-status">
                  <img class="img-thumbnail rounded-circle" [src]="user.picture" alt="Avatar" />
                  <div class="circle bg-success circle-lg"></div>
              </div>
          </div> -->
         
           
      </div>
      </li>
      <!-- END user info-->

      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/home']">
          <em class="fas fa-home"></em>

          <p style="vertical-align: text-bottom;">Home</p>
        </a>
      </li>
      <!-- <li [routerLinkActive]="['active']">
        <a [routerLink]="['/PayOut/PayoutDashboard']">
          <em class="fas  dash-icon"></em>

          <span style="vertical-align: text-bottom;"> Dashboard</span>
        </a>
      </li> -->
      <li [routerLinkActive]="['active']" *ngIf="NewPayout"> 
        <a [routerLink]="['/PayOut/NewPayOutContact']">
          <em class="fas  new-icon"></em>

          <p style="vertical-align: text-bottom;">New</p>
        </a>
      </li>
       
     
      <li [routerLinkActive]="['active']"  >
        <a [routerLink]="['/PayOut/AccountBalance']">
          <em class="fas fa-money-bill-alt"></em>

          <p style="vertical-align: text-bottom;">Manage</p>
        </a>

      </li>
      <li [routerLinkActive]="['active']"  >
        <a [routerLink]="['/PayOut/PayoutReports']">
          <em class="fas fa-book"></em>

          <p style="vertical-align: text-bottom;"> Reports</p>
        </a>

      </li>
      <li [routerLinkActive]="['active']"  >
        <a [routerLink]="['/PayOut/managePayoutAccountdetails']">
          <em class="fas fa-user-lock"></em>

          <p style="vertical-align: text-bottom;">Security</p>
        </a>

      </li>
     
      <li [routerLinkActive]="['active']">
        <a [routerLink]="['/Ticket/MangeTicket']">
          <em class="fas fa-ticket-alt"></em>
          <p style="vertical-align: text-bottom;">Support Ticket</p>
        </a>
      </li>
       

      



      <!-- <li [routerLinkActive]="['active']">



               
                <a  [routerLink]="['/PayOut/PayoutLedgers']">
                  <em class="fas  report-icon"></em>
        
                  <span style="vertical-align: text-bottom;">PayOut Reports</span>
                </a>
        
        
        
              </li>
         -->


    </ul>
    <!-- END sidebar nav-->

  </nav>
</div>
<!-- END Sidebar (left)-->